import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {InviteDeviceType} from '../../../_contracts/InviteContracts';
import {GuidanceWrapper, GuidanceImage, GuidanceTooltip, GuidanceImages} from './components';

import './styles.scss';

interface IAgentGuidance {
    stepNum: number | string;
    displayStepNum?: number;
    stepText?: string;
    stepType: string;
    deviceType: InviteDeviceType;
    tooltipPosition?: {
        top?: string;
        bottom?: string;
        left?: string;
        right?: string;
    };
    maxHeight?: string;
}

@observer
export class AgentGuidance extends TechseeBaseComponent<IAgentGuidance> {
    static Wrapper = GuidanceWrapper;

    static Image = GuidanceImage;

    static Images = GuidanceImages;

    static Tooltip = GuidanceTooltip;

    renderInternal() {
        const {deviceType, stepType, stepNum, displayStepNum, stepText, tooltipPosition, maxHeight} = this.props;

        this.addCssClass(deviceType);
        this.addCssClass(stepType);
        this.addCssClass('step-' + stepNum);

        return (
            <GuidanceWrapper className={this.renderCssClasses()}>
                <GuidanceImage name={`${stepType}-${stepNum}`} type={deviceType} isTransparent={stepNum === 'i'} />

                {stepText && (
                    <GuidanceTooltip
                        num={displayStepNum ?? stepNum}
                        text={stepText}
                        position={tooltipPosition}
                        maxHeight={maxHeight}
                    />
                )}
            </GuidanceWrapper>
        );
    }
}
